var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header", class: { "header-fixed": _vm.scrolled == true } },
    [
      _c("div", { staticClass: "header-top" }, [
        _c(
          "div",
          {
            staticClass: "user-wrapper",
            on: {
              mouseover: function ($event) {
                return _vm.updateFrontVersionDB()
              },
            },
          },
          [
            _c(
              "vs-dropdown",
              {
                attrs: {
                  "vs-custom-content": "",
                  "vs-trigger-click": "",
                  color: "#B20564",
                },
              },
              [
                this.userProp
                  ? _c(
                      "a",
                      { staticClass: "a-icon", attrs: { "href.prevent": "" } },
                      [
                        !this.userProp.avatar || !this.userProp.avatar.length
                          ? _c("img", {
                              attrs: {
                                src: require("../../assets/img/ico-man.svg"),
                              },
                            })
                          : _vm._e(),
                        this.userProp.avatar && !!this.userProp.avatar.length
                          ? _c("img", { attrs: { src: this.userProp.avatar } })
                          : _vm._e(),
                        this.userProp.firstname && this.userProp.lastname
                          ? _c("p", { staticClass: "user-name" }, [
                              _vm._v(
                                _vm._s(this.userProp.firstname) +
                                  " " +
                                  _vm._s(this.userProp.lastname)
                              ),
                            ])
                          : _vm._e(),
                        !this.userProp.firstname || !this.userProp.lastname
                          ? _c("p", { staticClass: "user-name" }, [
                              _vm._v(_vm._s(_vm.$t("dash.header.myaccount"))),
                            ])
                          : _vm._e(),
                        _c("i", { staticClass: "fa-solid fa-caret-down" }),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "vs-dropdown-menu",
                  { staticClass: "loginx" },
                  [
                    ["Admin", "Editor", "Writter"].includes(_vm.getUserRole)
                      ? _c(
                          "vs-dropdown-item",
                          {
                            on: {
                              click: () => {
                                this.$router.push({ path: "settings" })
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "dropdown-item" }, [
                              _c("a", [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/header/nav/ico-gear.svg"),
                                    alt: "settings",
                                  },
                                }),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.header.nav.settings")) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    [
                                      _vm._v(
                                        _vm._s(_vm.applicationVersion) +
                                          " \n                  "
                                      ),
                                      _vm.checkVersion
                                        ? _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text:
                                                  _vm.$t(
                                                    "dash.header.nav.new_front_version"
                                                  ) + _vm.checkVersion,
                                                position: "bottom",
                                              },
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("notifications")]
                                              ),
                                              _vm._v(
                                                "\n                     \n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    ["Admin", "Editor"].includes(_vm.getUserRole)
                      ? _c(
                          "vs-dropdown-item",
                          {
                            on: {
                              click: () => {
                                this.$router.push({ path: "settings/billing" })
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "dropdown-item" }, [
                              _c("a", [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/header/nav/ico-invoice.svg"),
                                    alt: "invoice",
                                  },
                                }),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("dash.header.nav.invoice"))
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _c("vs-dropdown-item", [
                      _c("div", { staticClass: "dropdown-item" }, [
                        _c(
                          "a",
                          { attrs: { href: "mailto:contact@mashup-web.com" } },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/header/nav/ico-support.svg"),
                                alt: "support",
                              },
                            }),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("dash.header.nav.support"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm.pwaInstalled &&
                    ["Admin", "Editor", "Writter"].includes(_vm.getUserRole)
                      ? _c("vs-dropdown-item", [
                          _c("div", { staticClass: "dropdown-item" }, [
                            _c("a", { on: { click: _vm.installPwa } }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/header/nav/pwa-install.svg"),
                                  alt: "application",
                                },
                              }),
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("dash.header.nav.pwa"))),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                    _c("vs-dropdown-item", [
                      _c("div", { staticClass: "dropdown-item" }, [
                        _c(
                          "a",
                          { attrs: { href: "/#/legal", target: "_blank" } },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/legal-icon.svg"),
                                alt: "legal",
                              },
                            }),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("dash.header.nav.legal"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _c(
                      "vs-dropdown-item",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.switchVersion()
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "dropdown-item" }, [
                          _c("a", { on: { click: _vm.logout } }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/header/nav/arrow-left-right.svg"),
                                alt: "logout",
                              },
                            }),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.version == "beta"
                                    ? _vm.$t(
                                        "dash.header.nav.switchVersion.old"
                                      )
                                    : _vm.$t(
                                        "dash.header.nav.switchVersion.beta"
                                      )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                    _c(
                      "vs-dropdown-item",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.change("logout")
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "dropdown-item" }, [
                          _c("a", { on: { click: _vm.logout } }, [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/img/header/nav/log-out.svg"),
                                alt: "logout",
                              },
                            }),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("dash.header.nav.logout"))),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        ["Admin", "Editor", "Writter"].includes(_vm.getUserRole) &&
        _vm.getUserPlan
          ? _c(
              "div",
              {
                staticClass: "add-post",
                class: [{ "pages-nav": _vm.isPagesNavSection }],
              },
              [
                _c(
                  "vs-button",
                  {
                    staticClass: "add-btn btn-large btn-img",
                    attrs: { color: "#6a1f4c", "vs-type": "filled" },
                    on: { click: _vm.goToPost },
                  },
                  [
                    _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.add")))]),
                    _c("img", {
                      attrs: {
                        src: require("../../assets/img/Add-icon.svg"),
                        alt: "search",
                      },
                    }),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo-wrapper" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: require("../../assets/img/logo_white.png"),
          alt: "Mashup logo",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }